export const vectors = "vectors";
export const visualisation = "visualisation";
export const revit = "revit";
export const about = "about";
export const work = "work";

export const pageChangeDelay = 2000;
export const colourChangeDelay = 10;
export const removingAnimation = 800;
